import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Select, Skeleton } from 'antd';

import { useGetUsers } from '@/hooks/useGetUsers';
import { useRosaContext } from '../../../../context';
import { useSectionActionPlan } from '../context';
import { Label, FormWrapper } from '../components';
import * as S from '../styles';

export function ResponsibleUser() {
	const { form_field_name } = useSectionActionPlan();
	const { organization_id, company_id } = useRosaContext();
	const { isLoading, data: responsibleUsers } = useGetUsers({ organization_id, company_id });

	const options = responsibleUsers?.map(({ id, name }) => ({
		label: name,
		value: id
	}));

	if (isLoading) {
		return (
			<Row>
				<Label>{I18n.get('Responsible')}</Label>
				<S.SkeletonWrapper span={24}>
					<Skeleton.Input active style={{ borderRadius: 6, width: '100%' }} />
				</S.SkeletonWrapper>
			</Row>
		);
	}

	return (
		<Row>
			<Label>{I18n.get('Responsible')}</Label>
			<FormWrapper name={[...form_field_name, 'responsible_user_id']}>
				<Select placeholder={I18n.get('Responsible')} options={options} />
			</FormWrapper>
		</Row>
	);
}
